import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Menus - Folded - INGAZ Print";

function MenusFolded() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          {/* Product Details Section */}
          <section className="product-details-section">
            <div className="product-container">
              {/* Left: Product Image Gallery */}
              <ProductGallery alt="Menus - Folded" images={[asset('assets/menus_folded.png'), asset('assets/menus_folded_angle.png'), asset('assets/menus_folded_detail.png'), asset('assets/menus_folded_var.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Menus - Folded" data-ar="القوائم">Menus - Folded</h1>
                <p className="product-description" data-en="Professional restaurant menus with high-quality printing and binding options." data-ar="قوائم مطاعم احترافية مع طباعة عالية الجودة وخيارات تجليد متنوعة.">Professional restaurant menus
                  with high-quality printing and binding options.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Year-Round" data-ar="طوال العام">Year-Round</div>
                      <div className="feature-detail" data-en="12 months" data-ar="12 شهرًا">12 months</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Durable materials resistant to spills and wear" data-ar="مواد متينة مقاومة للسوائل والاهتراء">
                      Durable materials resistant to spills and wear</li>
                    <li data-en="Vibrant color printing makes food look appetizing" data-ar="طباعة ألوان زاهية تجعل الطعام يبدو شهياً">
                      Vibrant color printing makes food look appetizing</li>
                    <li data-en="Variety of sizes and folding options" data-ar="مجموعة متنوعة من الأحجام وخيارات الطي">
                      Variety of sizes and folding options</li>
                    <li data-en="Easy to clean and maintain" data-ar="سهل التنظيف والصيانة">
                      Easy to clean and maintain</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/store.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Dine-in Menus" data-ar="قوائم المطاعم">Dine-in Menus</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/truck.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Takeout Menus" data-ar="قوائم التيك أواي">Takeout Menus</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Drink Specials" data-ar="عروض المشروبات">Drink Specials</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/location-dark.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Cafe Lists" data-ar="قوائم المقاهي">Cafe Lists</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          {/* Configuration Section */}
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Menus – Single Folded Sheet" data-ar="قم بتكوين القوائم – ورقة مطوية">Configure Your Menus – Single Folded Sheet</h2>
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={100} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>
                {/* Unfolded Size */}
                <div className="config-group">
                  <label data-en="Unfolded Size" data-ar="الحجم غير المطوي">Unfolded Size</label>
                  <div className="size-grid">
                    <div className="size-option" data-size="A3" data-dims="297x420">A3<br /><span>297x420</span></div>
                    <div className="size-option active" data-size="A4" data-dims="210x297">A4<br /><span>210x297</span></div>
                    <div className="size-option" data-size="A5" data-dims="148x210">A5<br /><span>148x210</span></div>
                    <div className="size-option" data-size="A6" data-dims="105x148">A6<br /><span>105x148</span></div>
                    <div className="size-option" data-size="A4Strip630" data-dims="297x630"><span>A4 Strip</span><br /><span>297 × 630 mm</span></div>
                    <div className="size-option" data-size="A4Strip840" data-dims="297x840"><span>A4 Strip</span><br /><span>297 × 840 mm</span></div>
                    <div className="size-option" data-size="A4Landscape" data-dims="594x210"><span>A4 Landscape Strip</span><br /><span>594 × 210 mm</span></div>
                    <div className="size-option" data-size="Other" data-dims="Custom"><span data-en="Other" data-ar="آخر">Other</span><br /><span data-en="L × W" data-ar="الطول × العرض">L × W</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Paper Type & Weight */}
                <div className="config-group">
                  <label htmlFor="paperType" data-en="Paper Type & Weight" data-ar="نوع الورق والوزن">Paper Type &amp; Weight</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="paperType">
                      <option value="couche-350">Couche 350 gsm</option>
                      <option value="couche-300">Couche 300 gsm</option>
                      <option value="couche-250">Couche 250 gsm</option>
                      <option value="couche-200">Couche 200 gsm</option>
                      <option value="couche-170">Couche 170 gsm</option>
                      <option value="couche-150">Couche 150 gsm</option>
                      <option value="white-120">White printing paper 120 gsm</option>
                      <option value="white-100">White printing paper 100 gsm</option>
                      <option value="white-80">White printing paper 80 gsm</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                {/* Printed Colors */}
                <div className="config-group">
                  <label data-en="Printed Colors" data-ar="الألوان المطبوعة">Printed Colors</label>
                  <div className="color-options">
                    <div className="color-option active" data-color="colored">
                      <img src={asset('assets/palette.svg')} alt="" className="color-icon" />
                      <div className="color-dots"><span className="dot red" /><span className="dot green" /><span className="dot blue" /></div>
                      <span data-en="Full Color" data-ar="ألوان كاملة">Full Color</span>
                    </div>
                    <div className="color-option" data-color="bw">
                      <div className="color-dots"><span className="dot black" /><span className="dot white" /></div>
                      <span data-en="Black & White" data-ar="أبيض وأسود">Black &amp; White</span>
                    </div>
                  </div>
                </div>
                {/* Printed Sides */}
                <div className="config-group">
                  <label data-en="Printed Sides" data-ar="الجوانب المطبوعة">Printed Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single"><img src={asset('assets/paperside.svg')} alt="" /><span>Single Side</span></div>
                    <div className="side-option" data-sides="double"><img src={asset('assets/paperside.svg')} alt="" /><img src={asset('assets/paperside.svg')} alt="" /><span>Double Sides</span></div>
                  </div>
                </div>
                {/* Lamination */}
                <div className="config-group">
                  <label data-en="Lamination" data-ar="التغليف">Lamination</label>
                  <div className="lamination-options">
                    <label className="radio-option"><input type="radio" name="lamination" defaultValue="none" defaultChecked /><span data-en="None" data-ar="لا شيء">None</span></label>
                    <label className="radio-option"><input type="radio" name="lamination" defaultValue="matt" /><img src={asset('assets/lamination.svg')} alt="" className="lamination-icon" /><span data-en="Matt Cellophane" data-ar="سيلوفان غير لامع">Matt Cellophane</span></label>
                    <label className="radio-option"><input type="radio" name="lamination" defaultValue="gloss" /><img src={asset('assets/lamination.svg')} alt="" className="lamination-icon" /><span data-en="Gloss Cellophane" data-ar="سيلوفان لامع">Gloss Cellophane</span></label>
                  </div>
                  <p className="config-note" data-en="Note: Cellophane should be dimmed in the case of all White Printing Paper" data-ar="ملاحظة: يجب أن يكون السيلوفان معتمًا في حالة جميع أوراق الطباعة البيضاء"><em>Note: Cellophane should be dimmed in the case of all White Printing Paper</em></p>
                </div>
                {/* Folding */}
                <div className="config-group">
                  <label data-en="Folding" data-ar="الطي">Folding</label>
                  <div className="lamination-options">
                    <label className="radio-option"><input type="radio" name="folding" defaultValue="half" defaultChecked /><span data-en="Half fold" data-ar="طي نصفي">Half fold</span></label>
                    <label className="radio-option"><input type="radio" name="folding" defaultValue="tri" /><span data-en="Tri-fold" data-ar="طي ثلاثي">Tri-fold</span></label>
                    <label className="radio-option"><input type="radio" name="folding" defaultValue="z" /><span data-en="Z-fold" data-ar="طي زد">Z-fold</span></label>
                    <label className="radio-option"><input type="radio" name="folding" defaultValue="gate" /><span data-en="Gate fold" data-ar="طي البوابة">Gate fold</span></label>
                  </div>
                </div>
                {/* Delivery Format */}
                <div className="config-group">
                  <label data-en="Delivery Format" data-ar="طريقة التسليم">Delivery Format</label>
                  <p className="config-hint" data-en="Please choose how you want to receive the leaflets:" data-ar="يرجى اختيار الطريقة التي تريد استلام المطويات بها:">Please choose how you want to receive the leaflets:</p>
                  <div className="lamination-options">
                    <label className="radio-option"><input type="radio" name="deliveryFormat" defaultValue="folded" defaultChecked /><span data-en="Delivered folded (we fold them for you)" data-ar="تسليم مطوية (نطويها لك)">Delivered folded (we fold them for you)</span></label>
                    <label className="radio-option"><input type="radio" name="deliveryFormat" defaultValue="flat" /><span data-en="Delivered flat with creasing (you fold them yourself)" data-ar="تسليم مسطحة مع التجعيد (تطويها بنفسك)">Delivered flat with creasing (you fold them yourself)</span></label>
                  </div>
                  <p className="config-note" data-en="Note: Creasing means we prepare the fold lines, but the sheets remain flat." data-ar="ملاحظة: التجعيد يعني أننا نجهز خطوط الطي، لكن الأوراق تبقى مسطحة."><em>Note: Creasing means we prepare the fold lines, but the sheets remain flat.</em></p>
                </div>
                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} defaultValue={""} />
                </div>
                {/* Upload Artwork */}
                <div className="config-group">
                  <label data-en="Upload Artwork" data-ar="رفع التصميم">Upload Artwork</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p>Drop your files here or browse</p>
                      <p className="upload-hint">Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>
                <NotesField />
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item"><span className="summary-label">Size:</span><span className="summary-value" id="summarySize">A4</span></div>
                  <div className="summary-item"><span className="summary-label">Paper:</span><span className="summary-value" id="summaryPaper">Couche 350 gsm</span></div>
                  <div className="summary-item"><span className="summary-label">Color:</span><span className="summary-value" id="summaryColor">Full Color</span></div>
                  <div className="summary-item"><span className="summary-label">Sides:</span><span className="summary-value" id="summarySides">Single Side</span></div>
                  <div className="summary-item"><span className="summary-label">Folding:</span><span className="summary-value" id="summaryFolding">Half fold</span></div>
                  <div className="summary-item"><span className="summary-label">Lamination:</span><span className="summary-value" id="summaryLamination">None</span></div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time">1-2 business days</div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item">✓ Free design review</div>
                  <div className="guarantee-item">✓ Quality guarantee</div>
                  <div className="guarantee-item">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">
                    Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Related Products Section */}
          <section className="related-products-section">
            <div className="related-products-container">
              <h2 data-en="Related Products" data-ar="منتجات ذات صلة">Related Products</h2>
              <p className="related-subtitle" data-en="Explore our full range of printing services" data-ar="استكشف مجموعة كاملة من خدمات الطباعة">Explore our full range of printing services</p>
              <div className="related-products-grid">
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image1.webp')} alt="Business Cards" />
                  </div>
                  <h3 data-en="Business Cards" data-ar="بطاقات العمل">Business Cards</h3>
                  <p data-en="Professional business cards" data-ar="بطاقات عمل احترافية">Professional business cards</p>
                  <a href="/business-cards" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image5.webp')} alt="Brochures" />
                  </div>
                  <h3 data-en="Brochures" data-ar="الكتيبات">Brochures</h3>
                  <p data-en="Multi-page marketing material" data-ar="مواد تسويقية متعددة الصفحات">Multi-page marketing
                    material</p>
                  <a href="/brochures" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image3.webp')} alt="Leaflets" />
                  </div>
                  <h3 data-en="Leaflets" data-ar="المنشورات المطوية">Leaflets</h3>
                  <p data-en="Folded marketing materials" data-ar="مواد تسويقية مطوية">Folded marketing materials</p>
                  <a href="/leaflets" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image7.webp')} alt="Catalogs" />
                  </div>
                  <h3 data-en="Catalogs" data-ar="الكتالوجات">Catalogs</h3>
                  <p data-en="Product catalogs & lookbooks" data-ar="كتالوجات المنتجات والكتيبات">Product catalogs &amp; lookbooks
                  </p>
                  <a href="/catalogues" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image8.webp')} alt="Menus - Folded" />
                  </div>
                  <h3 data-en="Menus - Folded" data-ar="القوائم">Menus - Folded</h3>
                  <p data-en="Restaurant quality printing" data-ar="طباعة بجودة المطاعم">Restaurant quality printing</p>
                  <a href="/menus" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default MenusFolded;

